const API_URL = process.env.REACT_APP_BACKEND_URL;

let cachedStatus = null;
let cacheExpiresAt = 0;
const CACHE_TTL_MS = 30_000;

export const PARTNER_SERVICES_UNAVAILABLE_TEST_ID = 'partner-services-unavailable';

export function partnerServicesStatusFromPayload(payload) {
  return Boolean(payload?.enabled);
}

export async function fetchPartnerServicesEnabled({ forceRefresh = false } = {}) {
  const now = Date.now();
  if (!forceRefresh && cachedStatus !== null && now < cacheExpiresAt) {
    return cachedStatus;
  }

  try {
    const response = await fetch(`${API_URL}/api/features/insurance-rental-cars/status`);
    if (!response.ok) {
      cachedStatus = false;
      cacheExpiresAt = now + CACHE_TTL_MS;
      return false;
    }
    const data = await response.json();
    cachedStatus = partnerServicesStatusFromPayload(data);
    cacheExpiresAt = now + CACHE_TTL_MS;
    return cachedStatus;
  } catch {
    cachedStatus = false;
    cacheExpiresAt = now + CACHE_TTL_MS;
    return false;
  }
}

export function resetPartnerServicesStatusCache() {
  cachedStatus = null;
  cacheExpiresAt = 0;
}
